/**
 * @desc 站点店铺-列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(
  params: API.basics.platformSiteShop.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
